import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { XpoErrorPagesModule } from '@xpo-ltl/ngx-ltl-core/error-pages';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { GridAppliedFiltersComponent } from './components/grid-applied-filters/grid-applied-filters.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { XpoChipsModule } from '@xpo-ltl/ngx-ltl-core/chips';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';
import { AppliedFiltersDisplayPipe } from './components/grid-applied-filters/helper/applied-filer.pipe';

@NgModule({
  declarations: [
    // Components
    NotAuthorizedComponent,
    AppliedFiltersDisplayPipe,
    GridAppliedFiltersComponent
    // Pipes/Directives

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    XpoIconModule,
    MatChipsModule,
    XpoChipsModule,
    MatTooltipModule,
    XpoErrorPagesModule,
    // Pipes/Directives
  ],
  exports: [
    // Components
    GridAppliedFiltersComponent,
    // Pipes/Directives
    AppliedFiltersDisplayPipe,
  ],
  // providers:  MAKE providedIn: 'root' on your services!!!
})
export class SharedModule {}
